import Vue from 'vue';
import router from '../../../ugsrc/router/index';
import { EventBus } from '../../../common/assets/utils/eventBus';

export const advancedSearchDetails = {
    namespaced: true,
    state: {
        enableAdvancedSearch : false,
        advancedSearchFilters : [],
        advancedSearchFilterValues : [],
        searchResults : [],
        searchedFilters : [],
        final_filters : {},
        tenantSeperatedDetails: {}
    },
    getters: {
      
    },
    actions: {
        getFiltersList({state, commit, dispatch}, data) {
            EventBus.$emit('showLoadingIcon', true);
            Vue.http.get('/fetch_advancedsearch_filters/')
            .then((res) => {
                commit('saveAllFiltersData', res.data);
                EventBus.$emit('showLoadingIcon', false);
            }, (error) => {
                commit('saveAllFiltersData', []);
                EventBus.$emit('showLoadingIcon', false);
                console.log("Something went Wrong: ", error);
            })
        },
    },
    mutations: {
        saveAllFiltersData(state, filtersData){
            state.advancedSearchFilters = filtersData.enabledFilters
            for ( let value in state.advancedSearchFilters)
            {
                state.advancedSearchFilters[value]['emittedValuesList'] = []
            }
            let filtered = state.searchedFilters.filter(item => item.emittedValuesList.length > 0 ? true : false)
            for( let value in filtered){
                let filteredArr = state.advancedSearchFilters.filter(item => item['key'] === filtered[value]['key'] ? true : false)
                if(filteredArr.length > 0 && filteredArr.length<2){
                    state.advancedSearchFilters.filter(item => item['key'] === filtered[value]['key'] ? true : false)[0]['emittedValuesList'] = filtered[value]['emittedValuesList']
                    state.advancedSearchFilters.filter(item => item['key'] === filtered[value]['key'] ? true : false)[0]['enableFilter'] = filtered[value]['enableFilter']
                }
            }
            // console.log(state.searchedFilters)
            // console.log(state.advancedSearchFilters)
            state.advancedSearchFilterValues = filtersData['filters']
        },
        
    },
  };
  